const { User } = require('@/models');
const { default: Contact } = require('../../../models/contact');

function getUserDetail() {
    return {
        route: 'organizationUser',
        endpoint: 'user',
        objectName: 'User',
        fields: ['id', 'companies {id name}', 'profilePicture{id key type}', 'name', 'vehicle{id name}', 'acls{id topic acc place}', 'hash', 'isSuper', 'skills{id name threshold}', 'availability{startDateTime endDateTime endTimeUnspecified recurrence}', 'depot{id name description streetAddress postalCode locality region country category}', 'projects {id name company{id}}', 'firstName', 'lastName', 'username', 'email', 'assignedRealmRoles{id name}', 'attributes{phone_number, jobtitle nickname birthdate gender locality locale iban bic postal_code street_address region country notes extra_email extra_phone description}'],
        tabs: [{
            tab: 'general',
            text: 'Algemeen'
        },
        {
            tab: 'address',
            text: 'Adres'
        },
        {
            tab: 'topics',
            text: 'MQTT Topics',
        },
        {
            tab: 'access',
            text: 'Toegang'
        },
        {
            tab: 'availability',
            text: 'Beschikbaarheid',
            visible(item, eod) {
                return eod.getUser().can('tasks.planning.menu');
            }
        },
        ],
        getTitle(item) {
            return item.firstName ? (item.firstName + ' ' + item.lastName) : (item.username ? item.username : '');
        }
    };
}

function getUserIndex() {
    return {
        route: 'organizationUsers',
        endpoint: 'users',
        filterName: 'organizationUsers',
        fields: ['id', 'profilePicture{key}', 'firstName', 'lastName', 'username', 'email', 'assignedRealmRoles{name}', 'createdTimestamp'],
        headers: [
            {
                text: '',
                value: 'profilePicture',
                component: () => import('@/components/columns/eod-column-avatar.vue'),
                width: 50
            },
            {
                text: 'Voornaam',
                value: 'firstName',
                component: () => import('./../../default/columns/link.vue')
            },
            {
                text: 'Familienaam',
                value: 'lastName',
                component: () => import('./../../default/columns/link.vue')
            },
            {
                text: 'Gebruikersnaam',
                value: 'username',
                component: () => import('./../../default/columns/link.vue')
            },
            {
                text: 'E-mailadres',
                value: 'email',
                component: () => import('./../../default/columns/link.vue')
            },
            {
                text: 'Rol',
                sortable: false,
                value: 'assignedRealmRoles',
                component: () => import('@/components/columns/eod-column-roles.vue')
            },
            {
                text: 'Aangemaakt',
                width: 250,
                value: 'createdTimestamp',
                component: () => import('@/components/columns/eod-column-date.vue')
            }, {
                width: 120,
                sortable: false,
                value: 'actions',
                draggable: false,
                component: () => import('@/components/columns/eod-column-actions.vue'),
                extra: {
                    deletePermission: 'organization.employees.delete'
                }
            }
        ],
        tabs: [{
            path: 'organization',
            text: 'Algemeen',
            permissions: ['organization.general.menu']
        },
        {
            path: 'organizationUsers',
            text: 'Medewerkers',
            permissions: ['organization.employees.menu']
        },
        {
            path: 'organizationContacts',
            text: 'Contacten',
            permissions: ['organization.contacts.menu']
        },
        {
            path: 'dataconnectors',
            text: 'Data connectors',
            permissions: ['organization.responsibles.menu']
        },
        {
            path: 'Teams',
            text: 'Teams',
            permissions: ['organization.teams.menu']
        },
        {
            path: 'organizationIntegrations',
            text: 'Koppelingen',
            permissions: ['organization.integrations.menu']
        },
        {
            path: 'organizationSettings',
            text: 'Instellingen',
            permissions: ['organization.settings.menu']
        }
        ],
    };
}

function getContactsIndex() {
    return {
        endpoint: 'users',
        fields: ['id', 'profilePicture{key}', 'firstName', 'lastName', 'username', 'email', 'assignedRealmRoles{name}', 'createdTimestamp'],
        headers: [{
            text: 'Voornaam',
            value: 'firstName',
            component: () => import('@/components/columns/eod-column-edit.vue')
        },
        {
            text: 'Familienaam',
            value: 'lastName',
            component: () => import('@/components/columns/eod-column-edit.vue')
        },
        {
            text: 'Gebruikersnaam',
            value: 'username',
            component: () => import('@/components/columns/eod-column-edit.vue')
        },
        {
            text: 'E-mailadres',
            value: 'email',
            component: () => import('@/components/columns/eod-column-edit.vue')
        },
        {
            text: 'Rol',
            sortable: false,
            value: 'assignedRealmRoles',
            component: () => import('@/components/columns/eod-column-roles.vue')
        },
        {
            text: 'Aangemaakt',
            width: 250,
            value: 'createdTimestamp',
            component: () => import('@/components/columns/eod-column-date.vue')
        }, {
            width: 120,
            sortable: false,
            value: 'actions',
            draggable: false,
            component: () => import('./columns/actions.vue'),
            extra: {
                deletePermission: 'organization.contacts.delete'
            }
        }
        ],
    };
}

module.exports = {
    routes: [
        {
            path: '/organization/users',
            name: 'organizationUsers',
            meta: {
                permissions: ['organization.employees.read'],
                roles: 'collaborators'
            },
            component: () => import('./views/index.vue')
        }, {
            path: '/organization/users/detail/:id?',
            name: 'organizationUser',
            meta: {
                permissions: ['organization.employees.update'],
                roles: 'collaborators'
            },
            component: () => import('./views/detail.vue')
        },
        {
            path: '/organization/contacts',
            name: 'organizationContacts',
            meta: {
                permissions: ['organization.contacts.read'],
                roles: 'contacts'
            },
            component: () => import('./views/index.vue')
        }, {
            path: '/organization/contacts/detail/:id?',
            name: 'organizationContact',
            meta: {
                permissions: ['organization.contacts.update'],
                roles: 'contacts'
            },
            component: () => import('./views/detail.vue')
        },
    ],
    search: User.searchConfig,
    itemObject: User,
    index: {
        ...getUserIndex(),
        intro: 'Beheer hier de medewerkers van uw organisatie. Medewerkers kunnen onder andere worden toegewezen aan taken en formulieren invullen via de mobile app.',
    },
    detail: getUserDetail(),
    contacts: {
        itemObject: Contact,
        search: User.searchConfig,
        index: {
            ...getUserIndex(),
            ...getContactsIndex(),
            intro: 'Beheer hier de contactpersonen van bedrijven en projecten. Contacten worden gebruikt voor externe communicatie en ondersteuning.',
            route: 'organizationContacts',
            filterName: 'organizationContacts',
        },
        detail: {
            ...getUserDetail(),
            route: 'organizationContact',
        },
    },
    import: {
        endpoint: 'users',
        objectName: 'User',
    },
}